module.exports = __webpack_public_path__ + "img/Swedish.9daf3c18.svg";